import script from "./Sucursales.vue?vue&type=script&setup=true&lang=js"
export * from "./Sucursales.vue?vue&type=script&setup=true&lang=js"

import "./Sucursales.vue?vue&type=style&index=0&id=36d26669&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d26669"]])

export default __exports__